"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * External dependencies
 */
var swiper_1 = __importDefault(require("swiper"));
var modules_1 = require("swiper/modules");
/* font dependencies */
require("@fontsource-variable/noto-sans-jp");
require("@fontsource-variable/noto-serif-jp");
require("@fontsource-variable/montserrat");
/** style dependencies */
require("./css/reboot.scss");
require("./css/frontend.scss");
require("swiper/css");
require("swiper/css/autoplay");
require("swiper/css/effect-fade");
/** Header */
var Header = function () {
    var header = document.querySelector('.wp-block-template-part:has(.is-position-sticky)');
    var className = 'is-state-scroll';
    if (header) {
        window.addEventListener('scroll', function () {
            var scrollY = window.scrollY;
            if (scrollY > 0 && !header.classList.contains(className)) {
                header.classList.add(className);
            }
            else if (scrollY <= 0 && header.classList.contains(className)) {
                header.classList.remove(className);
            }
        }, {});
    }
};
/* Go Top */
var GoTop = function () {
    var buttons = document.querySelectorAll('.gotop button');
    buttons.forEach(function (button) {
        button.addEventListener('click', function () {
            window.scrollTo({
                top: window.scrollY * -1,
                behavior: 'smooth',
            });
        }, {});
    });
};
/* Anchor */
var Anchor = function () {
    var buttons = document.querySelectorAll('.is-style-anchor .wp-block-button__link');
    var header = document.querySelector('.wp-block-group.is-position-sticky');
    buttons.forEach(function (button) {
        button.addEventListener('click', function (event) {
            event.preventDefault();
            var offset = 100;
            var header_height = header ? header.clientHeight : 0;
            var el = event.currentTarget;
            if (el) {
                var href = el.getAttribute('href');
                var target = document.querySelector(href ? href : '');
                var rect = target === null || target === void 0 ? void 0 : target.getBoundingClientRect();
                if (rect) {
                    window.scrollTo({
                        top: window.scrollY + rect.top - header_height - offset,
                        behavior: 'smooth',
                    });
                }
            }
        }, {});
    });
};
/** Carousel */
var Carousel = function () {
    var carousels = document.querySelectorAll('.carousel');
    carousels.forEach(function (carousel) {
        var swiperEl = carousel.querySelector('.swiper');
        if (swiperEl) {
            new swiper_1.default(swiperEl, {
                modules: [modules_1.Autoplay, modules_1.EffectFade],
                autoplay: {
                    delay: 5000,
                },
                speed: 3000,
                loop: true,
                effect: 'fade',
            });
        }
    });
};
window.addEventListener('DOMContentLoaded', function () {
    [
        Header,
        GoTop,
        Anchor,
        Carousel,
    ].forEach(function (fn) { return fn(); });
}, {});
